const ScreenLoading = () => {
  return (
    <div className=" h-screen flex justify-center items-center">
      <img
        src="/SIMPLD-Logo-blue.png"
        style={{
          width: "128px",
          height: "128px",
        }}
        className="animate-pulse"
      />
    </div>
  );
};
export default ScreenLoading;
